import { Node } from 'tiptap'
import { replaceText } from 'tiptap-commands'
import SuggestionsPlugin from '../Plugins/Suggs'

export default class VariableTag extends Node {

	get name() {
		return 'variabletag'
	}

	get defaultOptions() {
		return {
			matcher: {
				char: '{{',
				allowSpaces: false,
				startOfLine: false,
				spaceBefore: false, // only trigger match when character has a space (or start of line) before it
			},
			variableClass: 'variable',
			suggestionClass: 'vaiable-suggestion',
		}
	}

	get schema() {
		return {
			attrs: {
				id: {},
				label: {},
			},
			group: 'inline',
			inline: true,
			// selectable: false,
			draggable: true,
			atom: true,
			toDOM: node => [
				'span',
				{
					class: this.options.variableClass + ((node.attrs.id == 404)?' missing':'') ,
					'data-variable-id': node.attrs.id,
				},
				`${node.attrs.label}`,
			],
			parseDOM: [
			{
				tag: 'span[data-variable-id]',
				getAttrs: dom => {
					const id = dom.getAttribute('data-variable-id')
					// const label = dom.innerText.split(this.options.matcher.char).join('')
					const label = dom.innerText
					return { id, label }
				},
			},
			],
		}
	}

	commands({ schema }) {
		return attrs => replaceText(null, schema.nodes[this.name], attrs)
	}

	get plugins() {
		return [
			SuggestionsPlugin({
				command: ({ range, attrs, schema , state }) => {
					if(attrs.id=="ADD"){
						var self = this;

						self.options.onCreateClick();

						// Based on replaceText.js
						return (state,dispatch)=>{
							const { $from, $to } = state.selection
							const index = $from.index()
							const from = range ? range.from : $from.pos
							const to = range ? range.to : $to.pos

							if (dispatch) {
							  dispatch(state.tr.replace(from, to));
							}
						}
					}
					return replaceText(range, schema.nodes[this.name], attrs);
				},
				appendText: '',
				matcher: this.options.matcher,
				items: this.options.items,
				onEnter: this.options.onEnter,
				onChange: this.options.onChange,
				onExit: this.options.onExit,
				onKeyDown: this.options.onKeyDown,
				onFilter: this.options.onFilter,
				suggestionClass: this.options.suggestionClass,
			}),
		]
	}

}